module.exports = __webpack_public_path__ + "img/level_two_lock.88b3e786.png";